mutation updateMarketData($market_id: String!, $name: String!, $symbol: String!) {
    updateMarketData(market_id: $market_id, name: $name, symbol: $symbol)
}
